// 用户 id
const USER_ID_PARAMS = ['userId', 'empId', 'id']
// 用户 mucId
const MUC_UID_PARAMS = ['mucUid', 'uid']
// 用户名称
const USER_NAME_PARAMS = ['cn', 'name', 'userName', 'nameLangMap.cn', ...MUC_UID_PARAMS]
// 用户名称（英文）
const USER_NAME_EN_PARAMS = ['en', 'nameEn', 'userNameEn', 'nameLangMap.en', ...USER_NAME_PARAMS]
// 用户性别
const GENDER_PARAMS = ['gender']
// 用户工号
const EMPLOYEE_NUMBER_PARAMS = ['employeeNumber']
// 用户邮件
const EMAIL_PARAMS = ['email', 'mail']
// 用户电话
const MOBILE_PARAMS = ['mobile']
// 用户职级
const RANK_PARAMS = ['rank']
// 用户职位
const POSITION_NAME_PARAMS = [
  'positionName'
]
// 用户职位（英文）
const POSITION_NAME_EN_PARAMS = [
  'positionNameEn'
]
// 部门 id (部门i)
const DEPT_ID_PARAMS = [
  'departmentNumber',
  'deptNumber',
  'deptId',
  'id'
]
// 部门名称
const DEPT_NAME_PARAMS = [
  'departmentName',
  'deptName',
  'deptNameLangMap.cn'
]
// 部门名称（英文）
const DEPT_NAME_EN_PARAMS = [
  'departmentNameEn',
  'deptNameEn',
  'deptNameLangMap.en'
]
// 部门路径
const DEPT_PATH_PARAMS = [
  'departmentPathName',
  'deptNamePath',
  'deptNamePathLangMap.cn'
]
// 部门路径（英文）
const DEPT_PATH_EN_PARAMS = [
  'departmentPathNameEn',
  'deptNamePathEn',
  'deptNamePathLangMap.en'
]

// 性别：0 – 保密, 1 – 男 , 2 – 女

const DeptAttrs = {
  deptId: DEPT_ID_PARAMS,
  deptName: DEPT_NAME_PARAMS,
  deptNameEn: DEPT_NAME_EN_PARAMS,
  deptPath: DEPT_PATH_PARAMS,
  deptPathEn: DEPT_PATH_EN_PARAMS
}

const UserAttrs = {
  userId: USER_ID_PARAMS,
  mucUid: MUC_UID_PARAMS,
  userName: USER_NAME_PARAMS,
  userNameEn: USER_NAME_EN_PARAMS,
  gender: GENDER_PARAMS,
  employeeNumber: EMPLOYEE_NUMBER_PARAMS,
  email: EMAIL_PARAMS,
  mobile: MOBILE_PARAMS,
  rank: RANK_PARAMS,
  positionName: POSITION_NAME_PARAMS,
  positionNameEn: POSITION_NAME_EN_PARAMS,
  ...DeptAttrs
}

export {
  UserAttrs,
  DeptAttrs
}
